module.exports = __webpack_public_path__ + "static/media/IMG_5044.0ca50650.JPG";